var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-column-progress',{attrs:{"label":_vm.label,"sort":_vm.sort,"value":_vm.count,"required":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }